export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40851a509c0d10db3087ea873d07022731ea70230e&name=revalidateCommunity!'